import React from "react";

import Loader from "_components/atoms/loader";

import StepFour         from "./components/stepFour";
import StepOne          from "./components/stepOne";
import StepThree        from "./components/stepThree";
import StepTwo          from "./components/stepTwo";
import TotalEarningView from "./components/totalEarningView";
import withProcessSteps from "./withProcessSteps";

const steps = [ StepOne, StepTwo, StepThree, StepFour ];

const Process = ( { type, monetisationData, toggleFeedback, showTotalEarning, isMigratingData } ) => {

	let renderCheck = false;

	if ( showTotalEarning ) {

		const { title, earning } = monetisationData;

		return (
			<TotalEarningView earning = { earning }
				title                    = { title }
			/>
		);
	}

	// these checks are added only because we need to update component only when "type" and "monitisationData" are both updated
	const liveStreamCheck = ( ( type === "live" ) && monetisationData?.monetisationData?.length === 3 );
	const reelsCheck      = ( ( type === "reels" ) && monetisationData?.monetisationData?.length === 4 );

	// if showTotalEarning then dont show check
	renderCheck = liveStreamCheck || reelsCheck;

	const forceStep = 1;

	if ( !renderCheck ) {
		if ( isMigratingData )
			return (
				<StepOne currentStep = { monetisationData?.monetisationStatus }
					seperatorText       = { monetisationData?.monetisationStatus === 0 ? "Or" : "And one of the following" }
					stepData            = { monetisationData?.monetisationData?.[monetisationData?.monetisationStatus] }
					totalSteps          = { ( type === "live" ) ? 3 : 4 }
				/>
			);

		return <Loader />;
	}

	const currentStep = /* forceStep || */( monetisationData?.monetisationStatus );

	const totalSteps    = ( type === "live" ) ? 3 : 4;
	const seperatorText = currentStep === 0 ? "Or" : "And one of the following";

	const ProcessWithSteps = withProcessSteps ( steps, type, monetisationData, currentStep, totalSteps, seperatorText, toggleFeedback ) ( () => null );

	return <ProcessWithSteps />;
};

export default Process;
